export default __webpack_public_path__ + "static/media/Fail.0598d8d4.svg";